export class ApiFailure extends Error {
    status;
    body;
    constructor(status, body) {
        super(body.message);
        this.status = status;
        this.body = body;
    }
}
/** Builds the URL for an endpoint key, filling ":name" parameters and the query string. */
export function urlFor(key, params, query) {
    const path = key.slice(key.indexOf(' ') + 1).replace(/:([A-Za-z]+)/g, (_, n) => {
        const v = params?.[n];
        if (v === undefined)
            throw new Error(`missing parameter ${n} for ${key}`);
        return encodeURIComponent(v);
    });
    const qs = query ? Object.entries(query).filter(([, v]) => v !== undefined && v !== null && v !== '').map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`).join('&') : '';
    return qs ? `${path}?${qs}` : path;
}
/** Calls one endpoint of the contract. `base` is '' in the browser (same origin). */
export async function request(endpoint, opts = {}, base = '', init = {}) {
    const method = endpoint.slice(0, endpoint.indexOf(' '));
    const o = opts;
    const res = await fetch(base + urlFor(endpoint, o.params, o.query), {
        method,
        credentials: 'include',
        headers: o.body !== undefined ? { 'content-type': 'application/json' } : undefined,
        body: o.body !== undefined ? JSON.stringify(o.body) : undefined,
        ...init,
    });
    const text = await res.text();
    const data = text ? JSON.parse(text) : null;
    if (!res.ok)
        throw new ApiFailure(res.status, data ?? { error: 'http_' + res.status, message: res.statusText });
    return data;
}
//# sourceMappingURL=client.js.map